import {
  getAuthenticatedThemisClient,
  ConversionResultListView,
} from '@modifi/onboarding-api-clients'
import {EntityFactory} from '@modifi/redux'
import {createSelector} from 'reselect'
import {CurrencyVal} from '@modifi/enums'

import {AppThunkAction} from '../../types/redux'

const apiClient = getAuthenticatedThemisClient()

const {actions, reducer, selectors} = EntityFactory({
  actionNamePrefix: 'data/exchangeRate',
  reducerPath: ['data', 'exchangeRate', 'allRates'],
  fetchRequest: () => apiClient.ExchangeRate.fetchAll().then(res => res.data()),
})

export default reducer

const selectAllExchangeRates = (state: Record<string, any>): ConversionResultListView =>
  selectors.selectEntity(state) || {conversionResults: []}

export const selectCurrencyConversionRate = createSelector(
  selectAllExchangeRates,
  (state: Record<string, any>, fromCurrency: CurrencyVal, toCurrency: CurrencyVal) => ({
    fromCurrency,
    toCurrency,
  }),
  (exchangeRates, inputValues) =>
    exchangeRates?.conversionResults?.find(
      rates => rates?.from === inputValues?.fromCurrency && rates?.to === inputValues?.toCurrency
    )?.conversionRate || 1
)

export const aFetchAllExchangeRates = (): AppThunkAction => actions.fetch()
